import CirclesBackground from './CirclesBackground'

interface SectionHeroProps {
  title: string | null
  description?: string
}

function SectionHero({ title, description = '' }: SectionHeroProps) {
  return (
    <CirclesBackground className="p-8 lg:py-24">
      <h1 className="text-(--bg-color) my-6 text-center text-[2.75rem]">
        {title}
      </h1>
      <p className="text-(--bg-color) text-center">{description}</p>
    </CirclesBackground>
  )
}

export default SectionHero
